import React, { useState, useContext, useEffect } from "react";
import { encode } from "js-base64";
import { useNavigate } from "react-router";

import {
  getQueryParams,
  getPSI,
  handleSessionValidation,
  getRawDomainFromSearch,
} from "./Theme";
import { redirectPage } from "./Utils";
import LoaderPR from "./LoaderPR";
import { NotificationContext } from "./Notification";
import PasswordInput from "./PasswordInput";
import EmailInput from "./EmailInput";
import SSOService, { serviceUrl } from "./SSOService";
import { Form, HeaderForm, ContentForm, FooterForm } from "./Form";

function Login() {
  const domain = getRawDomainFromSearch();
  const id = getPSI();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showLoading, setLoading] = useState(true);
  const service = new SSOService();
  const queryParams = getQueryParams();
  const { addToast } = useContext(NotificationContext);
  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    handleSessionValidation(addToast).then(() => {
      setLoading(false);
    });
  }, []);
  return (
    <Form name="loginForm">
      <HeaderForm />
      <ContentForm>
        <EmailInput name="email" onChange={setUser} />
        <LoaderPR showLoading={showLoading} />
        <PasswordInput
          label="Password"
          name="password"
          autoComplete={true}
          onChange={(newPassword) => setPassword(newPassword)}
        />
        <a
          className="forget-pass zds-font-interaction-medium zds-text-system-neutral-800 zds-font-regular"
          href={`/forgot${queryParams}`}
        >
          Forgot your Password?
        </a>
      </ContentForm>
      <FooterForm>
        <button
          disabled={showLoading}
          className="zds-button-primary zds-button-large"
          type="submit"
          onClick={(event) => {
            event.preventDefault();
            if (user.trim() === "" || password.trim() === "") {
              addToast("User and password are required.", "error");
              return;
            }
            setLoading(true);
            handleSessionValidation(addToast).then(() => {
              service
                .login(user, password, id, domain)
                .then((data) => {
                  redirectPage(data.url);
                })
                .catch((err) => {
                  if (err.changePassword === true) {
                    const userEncoded = encode(user, true);
                    redirectPage(
                      `/setnewpassword/${userEncoded}${queryParams}`
                    );
                    return;
                  } else if (err.forceChangePassword === true) {
                    navigate(`/updatepassword${queryParams}`, {
                      state: { email: user, password, force: true },
                    });
                    return;
                  } else if (err.forgotPassword === true) {
                    redirectPage(`/forgot${queryParams}`);
                    return;
                  }
                  if (err.refreshSession === true) {
                    addToast("Your session expired.", "error");
                    redirectPage(
                      `${serviceUrl}/checklogin?returnUrl=${err.returnUrl}`
                    );
                    return;
                  }
                  setLoading(false);
                  addToast(
                    "Credentials are invalid, please contact support.",
                    "error"
                  );
                });
            });
          }}
        >
          Sign In
        </button>
        <p className="login-legal-notice">
          By logging in, you agree that PurpleLab may track your platform usage
          for internal analytics and service improvement purposes as set forth
          under our{" "}
          <a
            href="https://purplelab.com/legal"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use | PurpleLab®
          </a>{" "}
          or your applicable commercial agreement.
        </p>
      </FooterForm>
    </Form>
  );
}

export default Login;
